import { ApplicantInfo, OwnerInfo } from 'src/@types/application-types';

const clientId: string = '123';

export const owner1: OwnerInfo = {
  clientId,
  id: 'OWNER-PP',
  appId: 'APP-REJECTED',
  firstName: 'Gary',
  lastName: 'Katcher',
  phoneNumber: '4695551212',
  emailAddress: 'dev+uatrejected@libertasfunding.com',
  dateOfBirth: new Date('1970-05-15 00:00:00'),
  SSN: '123121233',
  percentOwnership: 100,
  homeStreetAddress1: '411 West Putnam Avenue Suite 220',
  homeStreetAddress2: '',
  city: 'Greenwich',
  state: 'CT',
  zip: '06830',
  userDate: '',
  createdAt: new Date(),
  updatedAt: new Date(),
};

export const applicantReject: ApplicantInfo = {
  clientId,
  id: 'App-Rejected-1',
  appId: 'APP-REJECTED',
  legalBusinessName: 'Sinister Six',
  industry: '11250',
  grossAnnualSales: 125000,
  requestedAmount: 45000,
  purposeOfCapital: 'Taxes',
  firstName: 'John',
  lastName: 'Smith',
  emailAddress: 'dev+uatrejected@libertasfunding.com',
  phoneNumber: '4695551212',
  password: 'GIVEMELIBERTY!2022',
  dba: 'S-Six',
  entityType: 'CORPORATION',
  businessStreetAddress1: '411 West Putnam Avenue Suite 220',
  businessStreetAddress2: '',
  businessCity: 'Greenwich',
  businessState: 'CT',
  businessZip: '06830',
  federalTaxID: '813053598',
  businessStartDate: new Date('2018-01-15 00:00:00'),
  businessPhone: '214551212',
  averageMonthlySales: 20000000,
  websiteURL: 'www.sinistersix.com',
  acceptsCreditCards: true,
  hasCurrentShortTermFinancing: true,
  owners: [owner1],
  userDate: '',
  businessInfoEdited: false,
  basicInfoEdited: false,
  ownerInfoEdited: false,
  // codatID: 'TBD',
  createdAt: new Date(),
  updatedAt: new Date(),
};
